// Build the authentication handoff without dropping planner query parameters.
// The original planner URL stays in Devise's stored location; these parameters
// keep the authentication pages in planner context while the user signs in or
// creates an account.
export function plannerSignInUrl(currentUrl) {
  const current = new URL(currentUrl, 'http://planner.local');
  const query = new URLSearchParams(current.search);
  query.set('from', 'planner');
  const suffix = query.toString();
  return `/users/sign_in${suffix ? `?${suffix}` : ''}`;
}
